// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-bg {
  background: var(--ion-color-secondary);
  width: auto;
  height: 100%;
  position: relative;
  overflow: hidden;
}

.header-row {
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
@media (min-width: 991px) {
  .header-row {
    height: 127px;
    padding-inline: 50px;
  }
}
.header-row app-burger-btn {
  margin-left: auto;
  --icon-color: var(--ion-color-primary);
}
@media (height < 770px) {
  .header-row app-burger-btn {
    margin-right: 10px;
  }
}

ion-header {
  --background: var(--ion-color-tertiary);
  background: var(--ion-color-tertiary);
}

.content-row {
  height: 100%;
}
.content-row .content-col {
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  padding: 70px 28px 30px;
  position: relative;
  z-index: 1;
}

.brand-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin: 10px 0 28px;
  color: var(--home-ink);
}
@media (height < 770px) {
  .brand-wrap {
    margin-bottom: 18px;
  }
}
@media (min-width: 991px) {
  .brand-wrap {
    margin-bottom: 16px;
  }
}

.brand-logo {
  width: 100%;
  height: 17vh;
  margin: 0px auto;
  --icon-color: var(--ion-color-secondary);
}

.brand-tagline {
  margin: 0;
  font-family: AppFontSemiBold;
  font-size: 12px;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: rgba(205, 165, 60, 0.9);
}

.card {
  background: var(--background-default);
  padding: 22px 20px 18px;
  margin: 0 auto;
  overflow: hidden;
  min-width: 300px;
  width: 100%;
  max-width: 375px;
  border: 0.6px solid var(--ion-color-primary);
  box-shadow: none;
  border-radius: 0.6px;
}
@media (height < 770px) {
  .card {
    padding: 14px 16px 12px;
  }
}
.card .overlay {
  padding-top: 0px;
  border-bottom: var(--outline-default);
  margin-bottom: 16px;
  position: relative;
}
.card .overlay img {
  width: 180px;
}

ion-spinner {
  color: #fff;
}

ion-footer {
  --background: transparent;
  background: transparent;
  overflow: hidden;
  position: absolute;
  bottom: 0;
  box-shadow: none;
}

.footer-lang {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: max-content;
  margin: 0 auto;
  gap: 10px;
}
.footer-lang div {
  text-align: center;
  width: 84px;
  height: 44px;
  border: 1px solid var(--color-black);
  background: var(--color-black);
  border-radius: var(--radius-default);
  overflow: hidden;
  padding: 8px 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: -moz-fit-content;
  width: fit-content;
  gap: 8px;
  min-width: 70px;
}
.footer-lang div p {
  font-family: AppFontMedium;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0.02em;
  vertical-align: middle;
  text-transform: uppercase;
  color: var(--color-white);
}
.footer-lang div ion-icon {
  height: 14px;
  width: 22px;
}
.footer-lang div.selected {
  background: var(--color-white);
}
.footer-lang div.selected p {
  color: var(--color-black);
}

.lang-block {
  padding-bottom: 25px;
}

.info-text {
  color: var(--home-ink);
  font-family: AppFont;
  font-weight: 400;
  font-size: 14px;
  line-height: 135%;
  text-align: center;
  vertical-align: middle;
  text-wrap: balance;
  margin-bottom: 10px;
}

.overlay-payment {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 6px;
  padding-bottom: 13px;
  border-top: 1px solid rgba(147, 147, 147, 0.5019607843);
  border-bottom: 1px solid rgba(147, 147, 147, 0.5019607843);
}
.overlay-payment .info-payment {
  font-family: AppFontMedium;
  font-size: 10px;
  line-height: 135%;
  letter-spacing: 0;
  text-align: center;
  vertical-align: middle;
  margin-bottom: 12px;
  color: var(--color-text-grey);
}
.overlay-payment .payment-icons {
  width: 100%;
  height: 16px;
}

.alergen-link {
  padding-top: 20px;
  padding-bottom: 10px;
  cursor: pointer;
  color: var(--color-text-grey);
  font-family: AppFontMedium;
  font-size: 14px;
  line-height: 135%;
  letter-spacing: 0.01em;
  text-align: center;
  text-decoration: underline;
  text-decoration-style: solid;
  text-decoration-offset: 0%;
  text-decoration-thickness: 1px;
}

ion-button {
  margin-bottom: 10px;
}

.title {
  padding-block: 15px;
  width: 180px;
  margin: 0 auto;
  font-family: AppFontMedium;
  font-size: 16px;
  line-height: 120%;
  letter-spacing: 0;
  text-align: center;
  color: #656564;
}

.subtitle {
  display: block;
  font-family: AppFontSemiBold;
  font-size: 24px;
  color: #1d1d1b;
  text-wrap: balance;
  margin-bottom: 10px;
}
@media (height < 770px) {
  .subtitle {
    font-size: 12px;
  }
}

.preorder-title {
  font-family: AppFont;
  font-size: 16px;
  font-weight: 500;
  color: #1d1d1b;
}
@media (height < 770px) {
  .preorder-title {
    font-size: 14px;
  }
}

@media (height < 770px) {
  .btn {
    height: 44px !important;
  }
}

.pointer {
  cursor: pointer;
}

.inputs-block {
  margin: 0 auto;
}

.input-block {
  position: relative;
  width: 85%;
  margin: 0 auto 12px;
}
.input-block ion-label {
  position: absolute;
  top: 3px;
  left: 50%;
  transform: translate(-50%, 0%);
  font-family: AppFontLight;
  font-size: 9px;
  line-height: 150%;
  letter-spacing: 0.01em;
  width: max-content;
  color: #4d5053;
}

ion-item {
  --height: 40px;
  border: 1px solid #c0c0bf;
  border-radius: var(--radius-default);
  --background: #ffffff !important;
  --min-height: var(--height);
  --inner-padding-end: 0;
}
ion-item.input-error {
  border: 0.8px solid #cc0e0e;
}
ion-item ion-input {
  font-family: AppFontMedium, sans-serif;
  font-size: 16px;
  line-height: 127%;
  letter-spacing: 0.01em;
  color: var(--color-black);
  text-align: center !important;
  --padding-top: 1px;
  min-height: var(--height);
}
ion-item ion-input.has-value {
  font-family: AppFontMedium, sans-serif;
}
ion-item ion-input ion-label {
  font-family: AppFontMedium;
  align-self: center;
}
ion-item:has(ion-checkbox) {
  border: none;
}
ion-item .input-error {
  border: 0.8px solid #7c1d16;
}

.error-text-block {
  position: absolute;
  left: 0;
  bottom: -13px;
  width: max-content;
}
.error-text-block .error-text {
  font-family: AppFontMedium;
  font-size: 8px;
  line-height: 135%;
  letter-spacing: 0;
  vertical-align: middle;
  margin: 0;
  color: #d13b2c;
}

.privacy-checkbox {
  width: 80%;
  margin: 0 auto 16px;
  --background: transparent !important;
}
.privacy-checkbox .checkbox-label {
  margin: 0;
  font-family: AppFontMedium;
  font-size: 12px;
  line-height: 135%;
  letter-spacing: 0em;
  text-align: left;
  color: var(--color-black);
  margin-bottom: 3px;
}
.privacy-checkbox ion-checkbox {
  height: 20px;
  --background: transparent;
  --background-checked: var(--ion-color-primary);
  --border-color: #939393;
  --border-color-checked: var(--ion-color-primary);
  --border-width: 1px;
  --checkmark-color: #fff;
  --checkmark-width: 3px;
  --border-radius: 3px;
  --size: 20px;
  margin: 0;
  margin-right: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/home/home.page.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,sCAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AADD;;AAGA;EACC,YAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAAD;ACZE;EDQF;IAME,aAAA;IACA,oBAAA;EAEA;AACF;AAAC;EACC,iBAAA;EACA,sCAAA;AAEF;AAAE;EAJD;IAKE,kBAAA;EAGD;AACF;;AACA;EACC,uCAAA;EACA,qCAAA;AAED;;AACA;EACC,YAAA;AAED;AAAC;EACC,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,UAAA;AAEF;;AAEA;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,sBAAA;AACD;AACC;EARD;IASE,mBAAA;EAEA;AACF;AC3DE;ED+CF;IAaE,mBAAA;EAGA;AACF;;AAAA;EACC,WAAA;EACA,YAAA;EACA,gBAAA;EACA,wCAAA;AAGD;;AAKA;EACC,SAAA;EACA,4BAAA;EACA,eAAA;EACA,sBAAA;EACA,yBAAA;EACA,8BAAA;AAFD;;AAKA;EACC,qCAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,4CAAA;EACA,gBAAA;EAEA,oBAAA;AAHD;AAKC;EAbD;IAcE,uBAAA;EAFA;AACF;AAIC;EAEC,gBAAA;EACA,qCAAA;EACA,mBAAA;EACA,kBAAA;AAHF;AAKE;EACC,YAAA;AAHH;;AAQA;EACC,WAAA;AALD;;AAQA;EACC,yBAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;AALD;;AAOA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;EACA,SAAA;AAJD;AAMC;EACC,kBAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,8BAAA;EACA,oCAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,QAAA;EACA,eAAA;AAJF;AAKE;EACC,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,sBAAA;EACA,yBAAA;EAEA,yBAAA;AAJH;AAME;EACC,YAAA;EACA,WAAA;AAJH;AAQE;EACC,8BAAA;AANH;AAQG;EACC,yBAAA;AANJ;;AAYA;EACC,oBAAA;AATD;;AAYA;EACC,sBAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EAEA,mBAAA;AAVD;;AAaA;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,oBAAA;EACA,uDAAA;EACA,0DAAA;AAVD;AAYC;EACC,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EAEA,mBAAA;EACA,6BAAA;AAXF;AAaC;EACC,WAAA;EACA,YAAA;AAXF;;AAcA;EACC,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,6BAAA;EAEA,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EAEA,kBAAA;EACA,0BAAA;EACA,4BAAA;EACA,0BAAA;EACA,8BAAA;AAbD;;AAgBA;EACC,mBAAA;AAbD;;AAgBA;EACC,mBAAA;EACA,YAAA;EACA,cAAA;EAEA,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EAEA,cAAA;AAfD;;AAkBA;EACC,cAAA;EACA,4BAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AAfD;AAiBC;EARD;IASE,eAAA;EAdA;AACF;;AAiBA;EACC,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAdD;AAgBC;EAND;IAOE,eAAA;EAbA;AACF;;AAiBC;EADD;IAEE,uBAAA;EAbA;AACF;;AAgBA;EACC,eAAA;AAbD;;AAgBA;EACC,cAAA;AAbD;;AAgBA;EACC,kBAAA;EACA,UAAA;EACA,mBAAA;AAbD;AAeC;EACC,kBAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EAEA,cAAA;AAdF;;AAkBA;EACC,cAAA;EAEA,yBAAA;EACA,oCAAA;EACA,gCAAA;EACA,2BAAA;EACA,sBAAA;AAhBD;AAkBC;EACC,2BAAA;AAhBF;AAmBC;EACC,sCAAA;EAEA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,6BAAA;EAGA,kBAAA;EACA,yBAAA;AApBF;AAsBE;EACC,sCAAA;AApBH;AAuBE;EACC,0BAAA;EACA,kBAAA;AArBH;AA4BC;EACC,YAAA;AA1BF;AA4BC;EACC,2BAAA;AA1BF;;AA8BA;EACC,kBAAA;EACA,OAAA;EACA,aAAA;EACA,kBAAA;AA3BD;AA6BC;EACC,0BAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,SAAA;EACA,cAAA;AA3BF;;AA+BA;EACC,UAAA;EACA,mBAAA;EACA,oCAAA;AA5BD;AA6BC;EACC,SAAA;EACA,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EAEA,kBAAA;AA5BF;AA+BC;EACC,YAAA;EAEA,yBAAA;EACA,8CAAA;EACA,uBAAA;EACA,gDAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,oBAAA;EACA,YAAA;EAEA,SAAA;EACA,kBAAA;AA/BF","sourcesContent":["@use '../../../theme/mixins' as *;\n\n.home-bg {\n\tbackground: var(--ion-color-secondary);\n\twidth: auto;\n\theight: 100%;\n\tposition: relative;\n\toverflow: hidden;\n}\n.header-row {\n\theight: 60px;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\t@include desktop {\n\t\theight: 127px;\n\t\tpadding-inline: 50px;\n\t}\n\n\tapp-burger-btn {\n\t\tmargin-left: auto;\n\t\t--icon-color: var(--ion-color-primary);\n\n\t\t@media (height < 770px) {\n\t\t\tmargin-right: 10px;\n\t\t}\n\t}\n}\n\nion-header {\n\t--background: var(--ion-color-tertiary);\n\tbackground: var(--ion-color-tertiary);\n}\n\n.content-row {\n\theight: 100%;\n\n\t.content-col {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: start;\n\t\talign-items: center;\n\t\tpadding: 70px 28px 30px;\n\t\tposition: relative;\n\t\tz-index: 1;\n\t}\n}\n\n.brand-wrap {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tgap: 8px;\n\tmargin: 10px 0 28px;\n\tcolor: var(--home-ink);\n\n\t@media (height < 770px) {\n\t\tmargin-bottom: 18px;\n\t}\n\n\t@include desktop {\n\t\tmargin-bottom: 16px;\n\t}\n}\n\n.brand-logo {\n\twidth: 100%;\n\theight: 17vh;\n\tmargin: 0px auto;\n\t--icon-color: var(--ion-color-secondary);\n\n\t// @media (height < 770px) {\n\t// \theight: 70px;\n\t// \twidth: 150px;\n\t// }\n}\n\n.brand-tagline {\n\tmargin: 0;\n\tfont-family: AppFontSemiBold;\n\tfont-size: 12px;\n\tletter-spacing: 0.18em;\n\ttext-transform: uppercase;\n\tcolor: rgba(205, 165, 60, 0.9);\n}\n\n.card {\n\tbackground: var(--background-default);\n\tpadding: 22px 20px 18px;\n\tmargin: 0 auto;\n\toverflow: hidden;\n\tmin-width: 300px;\n\twidth: 100%;\n\tmax-width: 375px;\n\tborder: 0.6px solid var(--ion-color-primary);\n\tbox-shadow: none;\n\t// backdrop-filter: blur(6px);\n\tborder-radius: 0.6px;\n\n\t@media (height < 770px) {\n\t\tpadding: 14px 16px 12px;\n\t}\n\n\t.overlay {\n\t\t// padding-bottom: 16px;\n\t\tpadding-top: 0px;\n\t\tborder-bottom: var(--outline-default);\n\t\tmargin-bottom: 16px;\n\t\tposition: relative;\n\n\t\timg {\n\t\t\twidth: 180px;\n\t\t}\n\t}\n}\n\nion-spinner {\n\tcolor: #fff;\n}\n\nion-footer {\n\t--background: transparent;\n\tbackground: transparent;\n\toverflow: hidden;\n\tposition: absolute;\n\tbottom: 0;\n\tbox-shadow: none;\n}\n.footer-lang {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tmax-width: max-content;\n\tmargin: 0 auto;\n\tgap: 10px;\n\n\tdiv {\n\t\ttext-align: center;\n\t\twidth: 84px;\n\t\theight: 44px;\n\t\tborder: 1px solid var(--color-black);\n\t\tbackground: var(--color-black);\n\t\tborder-radius: var(--radius-default);\n\t\toverflow: hidden;\n\t\tpadding: 8px 14px;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\twidth: fit-content;\n\t\tgap: 8px;\n\t\tmin-width: 70px;\n\t\tp {\n\t\t\tfont-family: AppFontMedium;\n\t\t\tfont-size: 14px;\n\t\t\tline-height: 100%;\n\t\t\tletter-spacing: 0.02em;\n\t\t\tvertical-align: middle;\n\t\t\ttext-transform: uppercase;\n\n\t\t\tcolor: var(--color-white);\n\t\t}\n\t\tion-icon {\n\t\t\theight: 14px;\n\t\t\twidth: 22px;\n\t\t}\n\t}\n\tdiv {\n\t\t&.selected {\n\t\t\tbackground: var(--color-white);\n\n\t\t\tp {\n\t\t\t\tcolor: var(--color-black);\n\t\t\t}\n\t\t}\n\t}\n}\n\n.lang-block {\n\tpadding-bottom: 25px;\n}\n\n.info-text {\n\tcolor: var(--home-ink);\n\tfont-family: AppFont;\n\tfont-weight: 400;\n\tfont-size: 14px;\n\tline-height: 135%;\n\ttext-align: center;\n\tvertical-align: middle;\n\ttext-wrap: balance;\n\n\tmargin-bottom: 10px;\n}\n\n.overlay-payment {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: center;\n\tpadding-top: 6px;\n\tpadding-bottom: 13px;\n\tborder-top: 1px solid #93939380;\n\tborder-bottom: 1px solid #93939380;\n\n\t.info-payment {\n\t\tfont-family: AppFontMedium;\n\t\tfont-size: 10px;\n\t\tline-height: 135%;\n\t\tletter-spacing: 0;\n\t\ttext-align: center;\n\t\tvertical-align: middle;\n\n\t\tmargin-bottom: 12px;\n\t\tcolor: var(--color-text-grey);\n\t}\n\t.payment-icons {\n\t\twidth: 100%;\n\t\theight: 16px;\n\t}\n}\n.alergen-link {\n\tpadding-top: 20px;\n\tpadding-bottom: 10px;\n\tcursor: pointer;\n\tcolor: var(--color-text-grey);\n\n\tfont-family: AppFontMedium;\n\tfont-size: 14px;\n\tline-height: 135%;\n\tletter-spacing: 0.01em;\n\n\ttext-align: center;\n\ttext-decoration: underline;\n\ttext-decoration-style: solid;\n\ttext-decoration-offset: 0%;\n\ttext-decoration-thickness: 1px;\n}\n\nion-button {\n\tmargin-bottom: 10px;\n}\n\n.title {\n\tpadding-block: 15px;\n\twidth: 180px;\n\tmargin: 0 auto;\n\n\tfont-family: AppFontMedium;\n\tfont-size: 16px;\n\tline-height: 120%;\n\tletter-spacing: 0;\n\ttext-align: center;\n\n\tcolor: #656564;\n}\n\n.subtitle {\n\tdisplay: block;\n\tfont-family: AppFontSemiBold;\n\tfont-size: 24px;\n\tcolor: #1d1d1b;\n\ttext-wrap: balance;\n\tmargin-bottom: 10px;\n\n\t@media (height < 770px) {\n\t\tfont-size: 12px;\n\t}\n}\n\n.preorder-title {\n\tfont-family: AppFont;\n\tfont-size: 16px;\n\tfont-weight: 500;\n\tcolor: #1d1d1b;\n\n\t@media (height < 770px) {\n\t\tfont-size: 14px;\n\t}\n}\n\n.btn {\n\t@media (height < 770px) {\n\t\theight: 44px !important;\n\t}\n}\n\n.pointer {\n\tcursor: pointer;\n}\n\n.inputs-block {\n\tmargin: 0 auto;\n}\n\n.input-block {\n\tposition: relative;\n\twidth: 85%;\n\tmargin: 0 auto 12px;\n\n\tion-label {\n\t\tposition: absolute;\n\t\ttop: 3px;\n\t\tleft: 50%;\n\t\ttransform: translate(-50%, 0%);\n\t\tfont-family: AppFontLight;\n\t\tfont-size: 9px;\n\t\tline-height: 150%;\n\t\tletter-spacing: 0.01em;\n\t\twidth: max-content;\n\n\t\tcolor: #4d5053;\n\t}\n}\n\nion-item {\n\t--height: 40px;\n\n\tborder: 1px solid #c0c0bf;\n\tborder-radius: var(--radius-default);\n\t--background: #ffffff !important;\n\t--min-height: var(--height);\n\t--inner-padding-end: 0;\n\n\t&.input-error {\n\t\tborder: 0.8px solid #cc0e0e;\n\t}\n\n\tion-input {\n\t\tfont-family: AppFontMedium, sans-serif;\n\n\t\tfont-size: 16px;\n\t\tline-height: 127%;\n\t\tletter-spacing: 0.01em;\n\t\tcolor: var(--color-black);\n\t\ttext-align: center !important;\n\n\t\t// --padding-start: 14px;\n\t\t--padding-top: 1px;\n\t\tmin-height: var(--height);\n\n\t\t&.has-value {\n\t\t\tfont-family: AppFontMedium, sans-serif;\n\t\t}\n\n\t\tion-label {\n\t\t\tfont-family: AppFontMedium;\n\t\t\talign-self: center;\n\t\t}\n\t}\n\n\t&:not(:has(ion-checkbox)) {\n\t}\n\n\t&:has(ion-checkbox) {\n\t\tborder: none;\n\t}\n\t.input-error {\n\t\tborder: 0.8px solid #7c1d16;\n\t}\n}\n\n.error-text-block {\n\tposition: absolute;\n\tleft: 0;\n\tbottom: -13px;\n\twidth: max-content;\n\n\t.error-text {\n\t\tfont-family: AppFontMedium;\n\t\tfont-size: 8px;\n\t\tline-height: 135%;\n\t\tletter-spacing: 0;\n\t\tvertical-align: middle;\n\t\tmargin: 0;\n\t\tcolor: #d13b2c;\n\t}\n}\n\n.privacy-checkbox {\n\twidth: 80%;\n\tmargin: 0 auto 16px;\n\t--background: transparent !important;\n\t.checkbox-label {\n\t\tmargin: 0;\n\t\tfont-family: AppFontMedium;\n\t\tfont-size: 12px;\n\t\tline-height: 135%;\n\t\tletter-spacing: 0em;\n\t\ttext-align: left;\n\t\tcolor: var(--color-black);\n\n\t\tmargin-bottom: 3px;\n\t}\n\n\tion-checkbox {\n\t\theight: 20px;\n\t\t// margin-top: -3px;\n\t\t--background: transparent;\n\t\t--background-checked: var(--ion-color-primary);\n\t\t--border-color: #939393;\n\t\t--border-color-checked: var(--ion-color-primary);\n\t\t--border-width: 1px;\n\t\t--checkmark-color: #fff;\n\t\t--checkmark-width: 3px;\n\t\t--border-radius: 3px;\n\t\t--size: 20px;\n\n\t\tmargin: 0;\n\t\tmargin-right: 10px;\n\t}\n\n\t// ion-checkbox::part(container) {\n\t// \tbackground: transparent;\n\t// }\n\n\t// ion-checkbox.checkbox-checked::part(container) {\n\t// \tbackground: #1ea45a;\n\t// \tborder-color: #1ea45a;\n\t// }\n\n\t// ion-checkbox.checkbox-checked::part(mark) {\n\t// \tcolor: #0f2a18;\n\t// }\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
